import * as React from "react";
import { prepareEmptyMarket, pickLiveOrPreliveId } from "../../../../../helpers";
import { renderMiniBetButtons } from "./renderMiniBetButtons";
/* istanbul ignore next */
export const renderMiniMarkets = (cardProps, buttonsHolderClass, componentPrefix) => {
    let marketsInConfig = cardProps.sport.config.markets;
    return (React.createElement("div", { key: `${componentPrefix}__buttons-holder__${cardProps.event.id}`, className: `rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${componentPrefix}-buttons-holder` }, marketsInConfig.map((m, index) => {
        let market = cardProps.markets.find(market => market.marketType.id === pickLiveOrPreliveId(m, cardProps.event.isLive));
        let emptyMarket = prepareEmptyMarket(cardProps.event.id, m.template, index);
        return renderMiniBetButtons(cardProps, market || emptyMarket, componentPrefix);
    })));
};
//# sourceMappingURL=renderMiniMarkets.js.map